import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import Select from 'react-select';
import { FormattedMessage } from 'react-intl';

const MySelectAutocomplete = (props) => {
  const {
    name,
    value,
    onChange,
    defaultValue,
    inputRef,
    menuItems,

    autoFocus,
    disabled,
    error,
  } = props;
  const theme = useTheme();

  const customStyles = {
    container: (provided) => ({
      ...provided,
      marginTop: '24px',
    }),
    control: (provided, state) => {
      let borderColor = '#ced4da';
      if (error) {
        borderColor = theme.palette.error.main;
      }
      if (state.menuIsOpen) {
        borderColor = theme.palette.primary.main;
      }
      return {
        ...provided,
        '&:hover': {
          borderColor,
        },
        '&:focus-within': {
          borderColor: theme.palette.primary.main,
        },
        minHeight: '43px',
        borderWidth: '2px',
        borderColor,
        backgroundColor: theme.palette.background.default,
        boxShadow: 'none',
      };
    },
    menu: (provided) => ({
      ...provided,
      backgroundColor: theme.palette.background.paper,
      zIndex: 2,
    }),
    option: (provided) => ({
      ...provided,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
    }),
  };

  const primaryColor = theme.palette.primary.main;
  const hoverColor = theme.palette.action.hover;

  const [internalValue, setInternalValue] = React.useState(defaultValue
    ? defaultValue.value : undefined);

  return (
    <>
      <input type="hidden" ref={inputRef} value={internalValue} />
      <Select
        theme={(selectTheme) => ({
          ...selectTheme,
          colors: {
            ...selectTheme.colors,
            primary: primaryColor,
            primary25: hoverColor,
          },
        })}
        styles={customStyles}
        value={value}
        onChange={(newValue) => {
          if (!onChange) {
            setInternalValue(newValue.value);
          } else {
            onChange({
              skipPersist: true,
              target: {
                name,
                value: newValue,
              },
            });
          }
        }}
        autoFocus={autoFocus}
        defaultValue={defaultValue}
        options={menuItems}
        isDisabled={disabled}
        name={name}
        placeholder={<FormattedMessage id="myselectautocomplete.placeholder" />}
        noOptionsMessage={() => <FormattedMessage id="myselectautocomplete.noOptionsMessage" />}
      />
    </>
  );
};

const mySelectValueAutocompletePropTypes = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
});

MySelectAutocomplete.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    mySelectValueAutocompletePropTypes,
    PropTypes.string, // empty string can be a value
  ]),
  onChange: PropTypes.func,
  defaultValue: PropTypes.oneOfType([
    mySelectValueAutocompletePropTypes,
    PropTypes.string, // empty string can be a value
  ]),
  inputRef: PropTypes.any,

  menuItems: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string,
    labelId: PropTypes.string,
  })),

  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

MySelectAutocomplete.defaultProps = {
  value: undefined,
  onChange: undefined,
  defaultValue: undefined,
  inputRef: undefined,
  menuItems: [],

  autoFocus: false,
  disabled: false,
  error: false,
};

export default MySelectAutocomplete;
